import { api } from '../../api/Axios';

const login = (email, password) => {
  const resource = 'manage/login';
  const data = { email, password };
  return api.post(resource, data);
};
export default { login };
